import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {StockBatchValuationReportModel} from "./stock-batch-valuation-report.model";

@Component({
    selector: "wbo-stock-batch-valuation-report",
    templateUrl: "./stock-batch-valuation-report.component.html",
    providers: [provideReportModel(StockBatchValuationReportModel)]
})
export class StockBatchValuationReportComponent extends AbstractReportPage {
    constructor(public model: StockBatchValuationReportModel) {
        super();
    }
}
